exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer {\n  position: relative;\n  bottom: 0;\n  background-color: grey;\n  width: 100%;\n  color: white;\n  padding: 1em 0;\n}\n#copyright {\n  text-align: center;\n  margin: 0px;\n  padding: 0;\n  text-align: center;\n  font-weight: bold;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/footer.component.css
// module id = 381
// module chunks = 1